import { NetworkConfig, useNetworkConfig } from "./useNetworkButtonConfig";
import { Chain, mainnet } from "viem/chains";

export const useSelectedNetworkConfig = (networkId: Chain["id"]): NetworkConfig => {
  const networkConfig = useNetworkConfig();
  const selectedNetwork = Object.values(networkConfig).find(props => props.id === networkId);
  return selectedNetwork ?? networkConfig[mainnet.id];
};
